module.exports = __webpack_public_path__ + "static/media/icons_Bilan Bronchiolite - ARB idf.debb32b3.svg";